/* Hududiy kabinet matnlari: kalit — o'zbekcha matn, qiymat — tarjima. `{0}` — qiymat o'rni. */
export const REGIONAL_RU: Record<string, string> = {
  "Uchastkani tahrirlash": "Редактирование участка",
  "boshlang'ich qoldiq: {0}": "начальный остаток: {0}",
  "bozorga chiqarish: {0}": "публикация на маркете: {0}",
  "Narx {0} so'm qilib saqlandi.": "Цена сохранена: {0} сум.",
  "rasm «{0}»: {1}": "фото «{0}»: {1}",
  "Hududiy boshqarma sifatida kirish": "Войти как региональное управление",
  " (bekor)": " (отменён)",
  " kishi": " чел.",
  " ta": " шт.",
  "60 kunda muddati tugaydi: {0} ta": "Срок истекает в течение 60 дней: {0}",
  ": xaritada nuqtalarni ketma-ket bosing, yakunlash uchun oxirgi nuqtani ikki marta bosing.": ": последовательно щёлкайте точки на карте, для завершения дважды щёлкните последнюю точку.",
  "Amal bajarilmadi.": "Операция не выполнена.",
  "Ariza": "Заявка",
  "Ariza raqami, kadastr yoki maqsad…": "Номер заявки, кадастр или цель…",
  "Ariza yo'q.": "Заявок нет.",
  "Arizalar": "Заявки",
  "Arizalar yo'q.": "Заявок нет.",
  "Auksion": "Аукцион",
  "Auksion boshlanishi": "Начало аукциона",
  "Auksion lotlari": "Аукционные лоты",
  "Auksion yakuni *": "Окончание аукциона *",
  "Auksionga chiqarilgan lotlar: ishtirokchilar, narx va holat": "Лоты, выставленные на аукцион: участники, цена и статус",
  "Barcha ma'lumotni bir joyda kiriting": "Введите все данные в одном месте",
  "Barcha ma'lumotni o'zgartirish mumkin": "Можно изменить все данные",
  "Batafsil": "Подробнее",
  "Bekor qilingan va boshqa": "Отменённые и прочие",
  "Bekor qilish": "Отмена",
  "Birlik narxi": "Цена за единицу",
  "Bo'sh qolsa — hozir boshlanadi.": "Если пусто — начнётся сейчас.",
  "Bosh sahifa": "Главная",
  "Boshlang'ich narx": "Начальная цена",
  "Boshlang'ich narx (so'm) *": "Начальная цена (сум) *",
  "Boshlang'ich qoldiq uchun kirim asosini tanlang.": "Выберите основание прихода для начального остатка.",
  "Boshlanishi": "Начало",
  "Boshqarish": "Управление",
  "Boshqarma": "Управление",
  "Boshqarma biriktirilmagan": "Управление не назначено",
  "Bosqich": "Этап",
  "Bozor": "Маркет",
  "Bozorda": "В маркете",
  "Bozorda emas": "Не в маркете",
  "Bozorda: {0} · Omborda qoldig'i bor: {1} · E'lon qilinmagan: {2}": "В маркете: {0} · С остатком на складе: {1} · Не опубликовано: {2}",
  "Bozordan olish": "Снять с маркета",
  "Bozorga chiqarish": "Выставить на маркет",
  "Bozorga chiqarish uchun narx 0 dan katta va omborda qoldiq bo'lishi kerak.": "Для публикации цена должна быть больше 0, а на складе — остаток.",
  "Bu holatda yuborish amali yo'q.": "В этом статусе отправка недоступна.",
  "Bu uchastka bo'yicha shartnoma yo'q.": "По этому участку нет договоров.",
  "Buyurtma": "Заказ",
  "Buyurtma bo'limlari": "Разделы заказов",
  "Buyurtma raqami yoki xaridor…": "Номер заказа или покупатель…",
  "Buyurtma yetkazilgan deb belgilandi.": "Заказ отмечен как доставленный.",
  "Buyurtma yuborildi, xaridorga xabar ketdi.": "Заказ отправлен, покупатель уведомлён.",
  "Buyurtmalar": "Заказы",
  "Buyurtmalar holati": "Статус заказов",
  "Buyurtmalar · {0}": "Заказы · {0}",
  "Chegara (GeoJSON) {0}": "Граница (GeoJSON) {0}",
  "Chegara biriktirildi: {0}": "Граница прикреплена: {0}",
  "Chegara o'zgarmaydi, qayta chizsangiz yangilanadi": "Граница не изменится; если перерисуете — обновится",
  "Chegarani qayta chizish": "Перерисовать границу",
  "Chegarasi (GeoJSON)": "Граница (GeoJSON)",
  "Cheklovlar": "Ограничения",
  "Daraxt / o'simlik turi": "Вид дерева / растения",
  "Davri": "Период",
  "E'lon qilinmoqda…": "Публикуется…",
  "E'lon qilish": "Опубликовать",
  "Eng yuqori joriy narx": "Наивысшая текущая цена",
  "Faol lotlar": "Активные лоты",
  "Faol savdoda": "В активных торгах",
  "Faoliyat turi": "Вид деятельности",
  "Fayl juda katta (5 MB gacha).": "Файл слишком большой (до 5 МБ).",
  "Foydalanish maqsadi": "Цель использования",
  "Foydalanish shartlari": "Условия использования",
  "G'olib": "Победитель",
  "GeoJSON fayl tanlash": "Выбрать файл GeoJSON",
  "GeoJSON ichida Polygon yoki MultiPolygon topilmadi.": "В GeoJSON не найден Polygon или MultiPolygon.",
  "GeoJSON koordinatalari noto'g'ri (uzunlik, kenglik tartibida bo'lishi kerak).": "Неверные координаты GeoJSON (порядок: долгота, широта).",
  "GeoJSON matni": "Текст GeoJSON",
  "GeoJSON noto'g'ri: JSON o'qib bo'lmadi.": "Неверный GeoJSON: не удалось прочитать JSON.",
  "Hammasi": "Все",
  "Hisob-kitob": "Расчёты",
  "Hisoblangan": "Начислено",
  "Holat": "Статус",
  "Hozircha buyurtma yo'q. Mahsulotlaringiz Yashil olamda sotib olingach shu yerda ko'rinadi.": "Заказов пока нет. Они появятся здесь, когда ваши товары купят в «Зелёном мире».",
  "Hudud biriktirilmagan": "Регион не назначен",
  "Hudud: {0}. Mahsulot shu boshqarma nomidan e'lon qilinadi.": "Регион: {0}. Товар публикуется от имени этого управления.",
  "Hududingiz invoyslari va tushgan to'lovlar": "Счета и поступившие платежи вашего региона",
  "Hududingiz mahsulotlari, ijara yerlari va to'lovlari": "Товары, арендные земли и платежи вашего региона",
  "Hududingiz mahsulotlari: yaratish, ombor, narx va Yashil olamga chiqarish": "Товары региона: создание, склад, цена и публикация в «Зелёном мире»",
  "Hududingiz mahsulotlariga tushgan buyurtmalar: yuborish va muammolar": "Заказы на товары вашего региона: отправка и проблемы",
  "Hududingiz uchastkalari xaritada: yangisini chizing yoki GeoJSON biriktiring, mavjudini tahrirlang yoki o'chiring": "Участки региона на карте: нарисуйте новый или прикрепите GeoJSON, измените или удалите существующий",
  "Hududingizdagi ijara uchastkalari reestri": "Реестр арендных участков региона",
  "Hududiy boshqarma": "Региональное управление",
  "Hujjat": "Документ",
  "Hujjat raqami *": "Номер документа *",
  "Ijara": "Аренда",
  "Ijara arizalari": "Заявки на аренду",
  "Ijara arizalari bosqichlari": "Этапы заявок на аренду",
  "Ijara arizalari va ularni rasmiylashtirish": "Заявки на аренду и их оформление",
  "Ijara bo'limini och": "Открой раздел аренды",
  "Ijara muddati": "Срок аренды",
  "Ijara muddati (yil) *": "Срок аренды (лет) *",
  "Ijara shartnomalari": "Договоры аренды",
  "Ijara turi *": "Тип аренды *",
  "Ijara uchastkalari": "Арендные участки",
  "Ijara uchastkalari holati": "Статус арендных участков",
  "Ijara uchastkalari · {0} ga": "Арендные участки · {0} га",
  "Ijarachi": "Арендатор",
  "Ijarachi yo'q": "Нет арендатора",
  "Ijarachi: {0}": "Арендатор: {0}",
  "Ijaraga mo'ljallangan uchastka auksionga chiqariladi": "Участок, предназначенный для аренды, выставляется на аукцион",
  "Invoys": "Счёт",
  "Invoys raqami yoki to'lovchi…": "Номер счёта или плательщик…",
  "Invoys yo'q.": "Счетов нет.",
  "Invoyslar": "Счета",
  "Ishtirokchilar": "Участники",
  "Izoh": "Примечание",
  "Izoh (ichki)": "Примечание (внутреннее)",
  "Jami": "Итого",
  "Jami ishtirokchilar": "Всего участников",
  "Jami summa": "Общая сумма",
  "Javob xaridorga yuborildi.": "Ответ отправлен покупателю.",
  "Joriy chegara: {0} ga. O'zgartirish uchun yangisini biriktiring.": "Текущая граница: {0} га. Чтобы изменить, прикрепите новую.",
  "Joriy narx": "Текущая цена",
  "Joriy oy to'lovlari · {0} ta": "Платежи за текущий месяц · {0}",
  "Kabinet bo'limlari": "Разделы кабинета",
  "Kadastr raqami": "Кадастровый номер",
  "Kadastr: {0}": "Кадастр: {0}",
  "Keyingi": "Далее",
  "Kirim asosi *": "Основание прихода *",
  "Kirim qayd etildi.": "Приход зарегистрирован.",
  "Kirim qilish": "Оприходовать",
  "Kiritilsa, boshlang'ich kirim sifatida omborga yoziladi.": "Если указано, записывается на склад как начальный приход.",
  "Ko'rish": "Открыть",
  "Kontur / vydel / kvartal": "Контур / выдел / квартал",
  "Kontur/kvartal": "Контур/квартал",
  "Lot": "Лот",
  "Lot bo'limlari": "Разделы лотов",
  "Lot e'lon qilish": "Опубликовать лот",
  "Lot raqami yoki maqsad…": "Номер лота или цель…",
  "Lot yo'q.": "Лотов нет.",
  "Lot {0} e'lon qilindi va «Ijara maydonlar» sahifasida ko'rinadi.": "Лот {0} опубликован и виден на странице «Арендные участки».",
  "Lot {0} qaytarib olindi.": "Лот {0} отозван.",
  "Lotlar": "Лоты",
  "Lotni qaytarib olish": "Отозвать лот",
  "Ma'lumot yo'q.": "Нет данных.",
  "Ma'lumotni yuklab bo'lmadi.": "Не удалось загрузить данные.",
  "Mahsulot": "Товар",
  "Mahsulot Yashil olamda e'lon qilindi.": "Товар опубликован в «Зелёном мире».",
  "Mahsulot bozordan olindi.": "Товар снят с маркета.",
  "Mahsulot kodi yoki nomi…": "Код или название товара…",
  "Mahsulot ma'lumotlari saqlandi.": "Данные товара сохранены.",
  "Mahsulot turi *": "Тип товара *",
  "Mahsulot yaratildi va Yashil olamda e'lon qilindi.": "Товар создан и опубликован в «Зелёном мире».",
  "Mahsulot yaratildi, lekin bajarilmadi — {0}. Tafsilotlar oynasida to'ldiring.": "Товар создан, но не выполнено — {0}. Дополните в окне деталей.",
  "Mahsulot yaratildi.": "Товар создан.",
  "Mahsulot yo'q.": "Товаров нет.",
  "Mahsulotlar": "Товары",
  "Mahsulotlar reestri": "Реестр товаров",
  "Mahsulotlar toifalar bo'yicha": "Товары по категориям",
  "Mahsulotlar · {0} tasi bozorda": "Товары · {0} в маркете",
  "Mahsulotlarim holati qanday?": "Каково состояние моих товаров?",
  "Mahsulotni tahrirlash": "Редактирование товара",
  "Manzil": "Адрес",
  "Maqsad": "Цель",
  "Mavjud miqdori (omborda)": "Наличное количество (на складе)",
  "Maydon": "Площадь",
  "Mening uchastkalarim": "Мои участки",
  "Minimal buyurtma": "Минимальный заказ",
  "Miqdor *": "Количество *",
  "Muddati": "Срок",
  "Muddati o'tgan invoyslar": "Просроченные счета",
  "Narx o'sish qadami (so'm)": "Шаг повышения цены (сум)",
  "Narxi": "Цена",
  "Narxni o'zgartirish": "Изменить цену",
  "Nomi": "Название",
  "Nomi (o'zbekcha) *": "Название (на узбекском) *",
  "Nomi (ruscha)": "Название (на русском)",
  "O'chirish": "Удалить",
  "O'lchov birligi *": "Единица измерения *",
  "O'rmon xo'jaligi": "Лесное хозяйство",
  "O'rmon xo'jaligi *": "Лесное хозяйство *",
  "O'sish qadami": "Шаг повышения",
  "Ochiq muammolar": "Открытые проблемы",
  "Ochiq muammolar: {0} ta": "Открытые проблемы: {0}",
  "Ochiq sahifada ko'rish": "Посмотреть на публичной странице",
  "Oldingi": "Назад",
  "Olib tashlash": "Убрать",
  "Ombor kirimi": "Приход на склад",
  "Omborda": "На складе",
  "Onlayn tranzaksiya yo'q.": "Онлайн-транзакций нет.",
  "Onlayn tranzaksiyalar": "Онлайн-транзакции",
  "Operatsiya turi *": "Тип операции *",
  "Oxirgi 12 oy: hisoblangan invoyslar va tushgan to'lovlar (mln so'm)": "Последние 12 месяцев: начисленные счета и поступившие платежи (млн сум)",
  "Oxirgi rasm o'chirildi.": "Последнее фото удалено.",
  "Oxirgisini o'chirish": "Удалить последнее",
  "Oy": "Месяц",
  "Oy bo'yicha filtr": "Фильтр по месяцу",
  "Oylar bo'yicha hisoblangan va to'langan summa": "Начисленная и оплаченная сумма по месяцам",
  "Penya": "Пеня",
  "Poligonda kamida 3 ta nuqta bo'lishi kerak.": "В полигоне должно быть не менее 3 точек.",
  "Publik portal": "Публичный портал",
  "Qarz": "Долг",
  "Qarz: {0} · To'langan: {1}": "Долг: {0} · Оплачено: {1}",
  "Qarzdorlar": "Должники",
  "Qarzdorlik": "Задолженность",
  "Qarzdorlik qancha?": "Какая задолженность?",
  "Qatorni bosing — ariza kartochkasida bosqichlar va ERI bilan tasdiqlash": "Нажмите на строку — в карточке заявки этапы и подтверждение ЭЦП",
  "Qatorni o'chirish": "Удалить строку",
  "Qiymati": "Значение",
  "Qoldiq": "Остаток",
  "Qolgan vaqt": "Осталось времени",
  "Raqam": "Номер",
  "Rasm qo'shish": "Добавить фото",
  "Rasm tanlash": "Выбрать фото",
  "Rasm yo'q.": "Фото нет.",
  "Rasm yuklandi.": "Фото загружено.",
  "Rasmlar": "Фото",
  "Rasmlar (ko'pi bilan {0} ta)": "Фото (не более {0})",
  "Reestr": "Реестр",
  "Ruxsat etilgan foydalanish": "Разрешённое использование",
  "Ruxsat etilgan qurilish": "Разрешённая застройка",
  "STIR": "ИНН",
  "Salom! Men Smart Forestry AI yordamchisiman. Hududingizdagi mahsulotlar, ijara va to'lovlar haqida so'rang yoki bo'limni ochishni ayting.": "Здравствуйте! Я ИИ-помощник Smart Forestry. Спрашивайте о товарах, аренде и платежах вашего региона или попросите открыть раздел.",
  "Sana": "Дата",
  "Saqlandi, lekin bajarilmadi — {0}.": "Сохранено, но не выполнено — {0}.",
  "Saqlanmoqda…": "Сохранение…",
  "Saqlash": "Сохранить",
  "Shartnoma": "Договор",
  "Shartnoma egalari": "Владельцы договоров",
  "Shartnoma raqami, ijarachi yoki STIR…": "Номер договора, арендатор или ИНН…",
  "Shartnoma yo'q.": "Договоров нет.",
  "Shartnoma: {0}": "Договор: {0}",
  "Shartnomalar": "Договоры",
  "Smart Forestry": "Smart Forestry",
  "Sotuv narxi": "Цена продажи",
  "Sotuv narxi (so'm)": "Цена продажи (сум)",
  "Summa": "Сумма",
  "Tahrirlash": "Редактировать",
  "Tavsif": "Описание",
  "Tavsiya etilgan narx (so'm)": "Рекомендуемая цена (сум)",
  "Telefon": "Телефон",
  "Tizim": "Система",
  "To'langan": "Оплачено",
  "To'langan / hisoblangan": "Оплачено / начислено",
  "To'lov bo'limlari": "Разделы платежей",
  "To'lov hujjati": "Платёжный документ",
  "To'lov hujjati raqami…": "Номер платёжного документа…",
  "To'lov kutilmoqda": "Ожидает оплаты",
  "To'lov kutilmoqda. To'lov tasdiqlangach buyurtmani yuborish mumkin bo'ladi.": "Ожидается оплата. После подтверждения платежа заказ можно будет отправить.",
  "To'lov muddati": "Срок оплаты",
  "To'lov yo'q.": "Платежей нет.",
  "To'lovlar": "Платежи",
  "To'lovlar dinamikasi": "Динамика платежей",
  "Tovarlar": "Товары",
  "Trek / yuk xati raqami": "Номер трека / накладной",
  "Trek raqami": "Номер трека",
  "Tugash": "Окончание",
  "Tugashi": "Окончание",
  "Tuman": "Район",
  "Uchastka": "Участок",
  "Uchastka *": "Участок *",
  "Uchastka ID, kadastr yoki ijarachi…": "ID участка, кадастр или арендатор…",
  "Uchastka ID, kadastr, ijarachi yoki STIR…": "ID участка, кадастр, арендатор или ИНН…",
  "Uchastka chegarasi (GeoJSON) kiritilmagan.": "Граница участка (GeoJSON) не указана.",
  "Uchastka chegarasini chizing yoki GeoJSON biriktiring.": "Нарисуйте границу участка или прикрепите GeoJSON.",
  "Uchastka topilmadi.": "Участок не найден.",
  "Uchastka {0} o'chirildi.": "Участок {0} удалён.",
  "Uchastka {0} o'chirilsinmi?": "Удалить участок {0}?",
  "Uchastka {0} qo'shildi.": "Участок {0} добавлен.",
  "Uchastka {0} saqlandi.": "Участок {0} сохранён.",
  "Uchastkalar": "Участки",
  "Uchastkalar ({0})": "Участки ({0})",
  "Uchastkalar hisob-kitobi ({0})": "Расчёты по участкам ({0})",
  "Uchastkalar kesimida: shartnoma egalari va shartnomalar": "По участкам: владельцы договоров и договоры",
  "Uchastkani qidirish": "Поиск участка",
  "Uchastkani qo'shish": "Добавить участок",
  "Undirish darajasi": "Уровень взыскания",
  "Usul": "Способ",
  "Xaridor": "Покупатель",
  "Xaridor muammolari": "Проблемы покупателя",
  "Xaridor qabul qilganini o'zi tasdiqlaydi. Tasdiqlamasa, shu yerdan belgilang.": "Покупатель подтверждает получение сам. Если не подтвердил, отметьте здесь.",
  "Xaritada chizing yoki GeoJSON fayl/matn biriktiring.": "Нарисуйте на карте или прикрепите файл/текст GeoJSON.",
  "Xaritada chizish": "Рисовать на карте",
  "Xaritada poligonni yoki ro'yxatdagi uchastkani tanlang.": "Выберите полигон на карте или участок в списке.",
  "Xo'jalik": "Хозяйство",
  "Xususiyat nomi": "Название характеристики",
  "Xususiyat qiymati": "Значение характеристики",
  "Xususiyat qo'shish": "Добавить характеристику",
  "Xususiyatlar (masalan: Uzunligi — 4 m)": "Характеристики (например: Длина — 4 м)",
  "Yakun": "Итог",
  "Yakuniy narx": "Итоговая цена",
  "Yakunlangan": "Завершён",
  "Yangi ariza": "Новая заявка",
  "Yangi chegara": "Новая граница",
  "Yangi mahsulot": "Новый товар",
  "Yangi uchastka": "Новый участок",
  "Yaratilgach darhol Yashil olamda e'lon qilish (narx va qoldiq kerak)": "Сразу после создания опубликовать в «Зелёном мире» (нужны цена и остаток)",
  "Yaratish": "Создать",
  "Yashil olamda": "В «Зелёном мире»",
  "Yer toifasi": "Категория земель",
  "Yetkazib berish shartlari": "Условия доставки",
  "Yetkazildi deb belgilash": "Отметить как доставленный",
  "Yetkazilgan": "Доставлено",
  "Yetkazilganlar summasi": "Сумма доставленных",
  "Yillik": "Годовая",
  "Yo'lda": "В пути",
  "Yoki GeoJSON matnini shu yerga qo'ying": "Или вставьте сюда текст GeoJSON",
  "Yuborilishi kerak": "К отправке",
  "Yuborish": "Отправить",
  "Yuborishga tayyor": "Готово к отправке",
  "Zakalat": "Задаток",
  "Zakalat puli (so'm)": "Сумма задатка (сум)",
  "Zaxira": "Запас",
  "avvalgi": "прежний",
  "bekor qilingan": "отменён",
  "bozorda": "в маркете",
  "e'lon qilingan": "опубликован",
  "e'lon qilinmagan": "не опубликован",
  "ga": "га",
  "hozirgi": "текущий",
  "mln so'm": "млн сум",
  "muammo: {0}": "проблема: {0}",
  "muddati tugagan": "срок истёк",
  "o'chirish": "удалить",
  "qabul qilingan": "принят",
  "{0} ga": "{0} га",
  "{0} ga · qarz {1}": "{0} га · долг {1}",
  "{0} kishi": "{0} чел.",
  "{0} kun kechikkan": "просрочка {0} дн.",
  "{0} · {1} ga": "{0} · {1} га",
  "«Ijaraga mo'ljallangan» uchastka yo'q: avval «Mening uchastkalarim» da uchastka qo'shing.": "Нет участков «Предназначен для аренды»: сначала добавьте участок в «Мои участки».",
  "— tanlang —": "— выберите —",
  "— tanlanmagan —": "— не выбрано —",
  "yan": "янв",
  "fev": "фев",
  "mar": "мар",
  "apr": "апр",
  "may": "май",
  "iyn": "июн",
  "iyl": "июл",
  "avg": "авг",
  "sen": "сен",
  "okt": "окт",
  "noy": "ноя",
  "dek": "дек",
  "Tugagan": "Завершённые",
  "Bekor qilingan": "Отменён",
  "Jarayondagilar": "В процессе",
  "Bekor qilingan lotlar": "Отменённые",
  "Bekor qilinganlar": "Отменённые",
  "Yetkazib tugallanganlar": "Доставленные и завершённые",
  "Uzoq muddatli ijara": "Долгосрочная аренда",
  "Muddatli foydalanish": "Срочное пользование",
  "Mavsumiy foydalanish": "Сезонное пользование",
  "Mavsumiy": "Сезонная",
  "Muddatli": "Срочная",
  "Uzoq muddatli": "Долгосрочная",
  "kutilmoqda": "ожидает",
  "muvaffaqiyatli": "успешно",
  "xato": "ошибка",
  "Ijaraga mo'ljallangan": "Предназначен для аренды",
  "Ijaraga chiqarildi": "Выставлен на аренду",
  "Foydalanishda": "В использовании",
  "Tugatilgan": "Прекращён",
  "Loyiha ariza": "Проект заявки",
  "Tekshiruvda": "На проверке",
  "Xatolik aniqlandi": "Выявлена ошибка",
  "O'rmon xo'jaligi tasdiqladi": "Лесхоз утвердил",
  "E-ijaraga yuborildi": "Отправлено в Е-аренду",
  "Loyihalashda": "В проектировании",
  "O'rmon xo'jaligi kelishuvida": "На согласовании в лесхозе",
  "Qayta ishlashga qaytarildi": "Возвращено на доработку",
  "Idoralararo kelishuvda": "На межведомственном согласовании",
  "Agentlik kelishuvida": "На согласовании в агентстве",
  "Kelishildi": "Согласовано",
  "Auksionga chiqarildi": "Выставлено на аукцион",
  "G'olib aniqlandi": "Победитель определён",
  "Ijaraga berildi": "Сдано в аренду",
  "Auksion amalga oshmadi": "Аукцион не состоялся",
  "Rad etildi": "Отклонено",
  "Shartnoma bekor qilindi": "Договор расторгнут",
  "Amaldagi ijara": "Действующая аренда",
  "Muddati yaqinlashmoqda": "Срок истекает",
  "Muddati tugagan": "Срок истёк",
  "Qarzdor": "Должник",
  "Qoidabuzarlik": "Нарушение",
  "Qoidabuzarlik aniqlangan": "Выявлено нарушение",
  "Faol": "Активный",
  "Sotuvda": "В продаже",
  "Yopilgan": "Закрыт",
  "Cheklangan": "Ограничен",
  "Amalda": "Действует",
  "To'xtatilgan": "Приостановлен",
  "Yangi": "Новый",
  "Qisman to'langan": "Частично оплачен",
  "Muddati o'tgan": "Просрочен",
  "G'aznachilik": "Казначейство",
  "Bank o'tkazmasi": "Банковский перевод",
  "Naqd": "Наличные",
  "Onlayn to'lov": "Онлайн-оплата",
  "Qabul qilindi": "Принят",
  "Qayta kelishuv": "Повторное согласование",
  "To'landi": "Оплачен",
  "Yetkazilmoqda": "Доставляется",
  "Yetkazildi": "Доставлен",
  "Bekor qilindi": "Отменён",
  "Faol savdo": "Активные торги",
  "Muvaffaqiyatli yakunlangan": "Успешно завершён",
  "O'tkazilmagan deb topilgan": "Признан несостоявшимся",
  "Shartnoma yaratish jarayonida": "Идёт оформление договора",
  "Loyihalash": "Проектирование",
  "O'rmon xo'jaligi tashkilotida": "В лесохозяйственной организации",
  "Idoraviy kelishuv": "Межведомственное согласование",
  "O'rmon xo'jaligi agentligi": "Агентство лесного хозяйства",
  "E-AUKSION": "E-AUKSION",
  "Davlat kadastrlari palatasi": "Палата государственных кадастров",
  "Kutilmoqda": "Ожидается",
  "Ko'rib chiqilmoqda": "Рассматривается",
  "Yakunlandi": "Завершён",
};

/* Hududiy kabinet matnlari: kalit — o'zbekcha matn, qiymat — tarjima. `{0}` — qiymat o'rni. */
export const REGIONAL_EN: Record<string, string> = {
  "Uchastkani tahrirlash": "Edit plot",
  "boshlang'ich qoldiq: {0}": "opening stock: {0}",
  "bozorga chiqarish: {0}": "publishing to market: {0}",
  "Narx {0} so'm qilib saqlandi.": "Price saved: {0} UZS.",
  "rasm «{0}»: {1}": "image “{0}”: {1}",
  "Hududiy boshqarma sifatida kirish": "Sign in as a regional department",
  " (bekor)": " (cancelled)",
  " kishi": " people",
  " ta": " pcs",
  "60 kunda muddati tugaydi: {0} ta": "Expiring within 60 days: {0}",
  ": xaritada nuqtalarni ketma-ket bosing, yakunlash uchun oxirgi nuqtani ikki marta bosing.": ": click points on the map one by one, double-click the last point to finish.",
  "Amal bajarilmadi.": "The action failed.",
  "Ariza": "Application",
  "Ariza raqami, kadastr yoki maqsad…": "Application no., cadastre or purpose…",
  "Ariza yo'q.": "No applications.",
  "Arizalar": "Applications",
  "Arizalar yo'q.": "No applications.",
  "Auksion": "Auction",
  "Auksion boshlanishi": "Auction start",
  "Auksion lotlari": "Auction lots",
  "Auksion yakuni *": "Auction end *",
  "Auksionga chiqarilgan lotlar: ishtirokchilar, narx va holat": "Lots put up for auction: participants, price and status",
  "Barcha ma'lumotni bir joyda kiriting": "Enter all the details in one place",
  "Barcha ma'lumotni o'zgartirish mumkin": "All details can be edited",
  "Batafsil": "Details",
  "Bekor qilingan va boshqa": "Cancelled and other",
  "Bekor qilish": "Cancel",
  "Birlik narxi": "Unit price",
  "Bo'sh qolsa — hozir boshlanadi.": "If left empty, it starts now.",
  "Bosh sahifa": "Home",
  "Boshlang'ich narx": "Starting price",
  "Boshlang'ich narx (so'm) *": "Starting price (UZS) *",
  "Boshlang'ich qoldiq uchun kirim asosini tanlang.": "Choose the receipt basis for the opening stock.",
  "Boshlanishi": "Start",
  "Boshqarish": "Manage",
  "Boshqarma": "Department",
  "Boshqarma biriktirilmagan": "No department assigned",
  "Bosqich": "Stage",
  "Bozor": "Market",
  "Bozorda": "On the market",
  "Bozorda emas": "Not on the market",
  "Bozorda: {0} · Omborda qoldig'i bor: {1} · E'lon qilinmagan: {2}": "On the market: {0} · In stock: {1} · Unpublished: {2}",
  "Bozordan olish": "Remove from market",
  "Bozorga chiqarish": "Publish to market",
  "Bozorga chiqarish uchun narx 0 dan katta va omborda qoldiq bo'lishi kerak.": "To publish, the price must be above 0 and there must be stock.",
  "Bu holatda yuborish amali yo'q.": "Shipping is not available in this status.",
  "Bu uchastka bo'yicha shartnoma yo'q.": "No contracts for this plot.",
  "Buyurtma": "Order",
  "Buyurtma bo'limlari": "Order sections",
  "Buyurtma raqami yoki xaridor…": "Order no. or buyer…",
  "Buyurtma yetkazilgan deb belgilandi.": "The order is marked as delivered.",
  "Buyurtma yuborildi, xaridorga xabar ketdi.": "The order was shipped and the buyer was notified.",
  "Buyurtmalar": "Orders",
  "Buyurtmalar holati": "Order status",
  "Buyurtmalar · {0}": "Orders · {0}",
  "Chegara (GeoJSON) {0}": "Boundary (GeoJSON) {0}",
  "Chegara biriktirildi: {0}": "Boundary attached: {0}",
  "Chegara o'zgarmaydi, qayta chizsangiz yangilanadi": "The boundary stays the same unless you redraw it",
  "Chegarani qayta chizish": "Redraw boundary",
  "Chegarasi (GeoJSON)": "Boundary (GeoJSON)",
  "Cheklovlar": "Restrictions",
  "Daraxt / o'simlik turi": "Tree / plant species",
  "Davri": "Period",
  "E'lon qilinmoqda…": "Publishing…",
  "E'lon qilish": "Publish",
  "Eng yuqori joriy narx": "Highest current price",
  "Faol lotlar": "Active lots",
  "Faol savdoda": "Active",
  "Faoliyat turi": "Activity type",
  "Fayl juda katta (5 MB gacha).": "The file is too large (up to 5 MB).",
  "Foydalanish maqsadi": "Intended use",
  "Foydalanish shartlari": "Terms of use",
  "G'olib": "Winner",
  "GeoJSON fayl tanlash": "Choose GeoJSON file",
  "GeoJSON ichida Polygon yoki MultiPolygon topilmadi.": "No Polygon or MultiPolygon found in the GeoJSON.",
  "GeoJSON koordinatalari noto'g'ri (uzunlik, kenglik tartibida bo'lishi kerak).": "Invalid GeoJSON coordinates (order must be longitude, latitude).",
  "GeoJSON matni": "GeoJSON text",
  "GeoJSON noto'g'ri: JSON o'qib bo'lmadi.": "Invalid GeoJSON: could not parse JSON.",
  "Hammasi": "All",
  "Hisob-kitob": "Settlements",
  "Hisoblangan": "Accrued",
  "Holat": "Status",
  "Hozircha buyurtma yo'q. Mahsulotlaringiz Yashil olamda sotib olingach shu yerda ko'rinadi.": "No orders yet. They will appear here once your products are bought on Green World.",
  "Hudud biriktirilmagan": "No region assigned",
  "Hudud: {0}. Mahsulot shu boshqarma nomidan e'lon qilinadi.": "Region: {0}. The product is published in this department's name.",
  "Hududingiz invoyslari va tushgan to'lovlar": "Invoices and payments received in your region",
  "Hududingiz mahsulotlari, ijara yerlari va to'lovlari": "Your region's products, leased land and payments",
  "Hududingiz mahsulotlari: yaratish, ombor, narx va Yashil olamga chiqarish": "Your region's products: create, stock, price and publish to Green World",
  "Hududingiz mahsulotlariga tushgan buyurtmalar: yuborish va muammolar": "Orders for your region's products: shipping and issues",
  "Hududingiz uchastkalari xaritada: yangisini chizing yoki GeoJSON biriktiring, mavjudini tahrirlang yoki o'chiring": "Your region's plots on the map: draw a new one or attach GeoJSON, edit or delete an existing one",
  "Hududingizdagi ijara uchastkalari reestri": "Register of leased plots in your region",
  "Hududiy boshqarma": "Regional department",
  "Hujjat": "Document",
  "Hujjat raqami *": "Document number *",
  "Ijara": "Lease",
  "Ijara arizalari": "Lease applications",
  "Ijara arizalari bosqichlari": "Lease application stages",
  "Ijara arizalari va ularni rasmiylashtirish": "Lease applications and processing",
  "Ijara bo'limini och": "Open the lease section",
  "Ijara muddati": "Lease term",
  "Ijara muddati (yil) *": "Lease term (years) *",
  "Ijara shartnomalari": "Lease contracts",
  "Ijara turi *": "Lease type *",
  "Ijara uchastkalari": "Leased plots",
  "Ijara uchastkalari holati": "Leased plot status",
  "Ijara uchastkalari · {0} ga": "Leased plots · {0} ha",
  "Ijarachi": "Lessee",
  "Ijarachi yo'q": "No lessee",
  "Ijarachi: {0}": "Lessee: {0}",
  "Ijaraga mo'ljallangan uchastka auksionga chiqariladi": "A plot designated for lease is put up for auction",
  "Invoys": "Invoice",
  "Invoys raqami yoki to'lovchi…": "Invoice no. or payer…",
  "Invoys yo'q.": "No invoices.",
  "Invoyslar": "Invoices",
  "Ishtirokchilar": "Participants",
  "Izoh": "Note",
  "Izoh (ichki)": "Note (internal)",
  "Jami": "Total",
  "Jami ishtirokchilar": "Total participants",
  "Jami summa": "Total amount",
  "Javob xaridorga yuborildi.": "The reply was sent to the buyer.",
  "Joriy chegara: {0} ga. O'zgartirish uchun yangisini biriktiring.": "Current boundary: {0} ha. Attach a new one to change it.",
  "Joriy narx": "Current price",
  "Joriy oy to'lovlari · {0} ta": "This month's payments · {0}",
  "Kabinet bo'limlari": "Cabinet sections",
  "Kadastr raqami": "Cadastre number",
  "Kadastr: {0}": "Cadastre: {0}",
  "Keyingi": "Next",
  "Kirim asosi *": "Receipt basis *",
  "Kirim qayd etildi.": "Receipt recorded.",
  "Kirim qilish": "Receive stock",
  "Kiritilsa, boshlang'ich kirim sifatida omborga yoziladi.": "If entered, it is recorded as the opening stock receipt.",
  "Ko'rish": "View",
  "Kontur / vydel / kvartal": "Contour / compartment / block",
  "Kontur/kvartal": "Contour/block",
  "Lot": "Lot",
  "Lot bo'limlari": "Lot sections",
  "Lot e'lon qilish": "Publish a lot",
  "Lot raqami yoki maqsad…": "Lot no. or purpose…",
  "Lot yo'q.": "No lots.",
  "Lot {0} e'lon qilindi va «Ijara maydonlar» sahifasida ko'rinadi.": "Lot {0} is published and visible on the “Lease plots” page.",
  "Lot {0} qaytarib olindi.": "Lot {0} was withdrawn.",
  "Lotlar": "Lots",
  "Lotni qaytarib olish": "Withdraw lot",
  "Ma'lumot yo'q.": "No data.",
  "Ma'lumotni yuklab bo'lmadi.": "Could not load the data.",
  "Mahsulot": "Product",
  "Mahsulot Yashil olamda e'lon qilindi.": "The product is published on Green World.",
  "Mahsulot bozordan olindi.": "The product was removed from the market.",
  "Mahsulot kodi yoki nomi…": "Product code or name…",
  "Mahsulot ma'lumotlari saqlandi.": "Product details saved.",
  "Mahsulot turi *": "Product type *",
  "Mahsulot yaratildi va Yashil olamda e'lon qilindi.": "The product was created and published on Green World.",
  "Mahsulot yaratildi, lekin bajarilmadi — {0}. Tafsilotlar oynasida to'ldiring.": "The product was created, but this failed — {0}. Complete it in the details window.",
  "Mahsulot yaratildi.": "The product was created.",
  "Mahsulot yo'q.": "No products.",
  "Mahsulotlar": "Products",
  "Mahsulotlar reestri": "Product register",
  "Mahsulotlar toifalar bo'yicha": "Products by category",
  "Mahsulotlar · {0} tasi bozorda": "Products · {0} on the market",
  "Mahsulotlarim holati qanday?": "What is the status of my products?",
  "Mahsulotni tahrirlash": "Edit product",
  "Manzil": "Address",
  "Maqsad": "Purpose",
  "Mavjud miqdori (omborda)": "Available quantity (in stock)",
  "Maydon": "Area",
  "Mening uchastkalarim": "My plots",
  "Minimal buyurtma": "Minimum order",
  "Miqdor *": "Quantity *",
  "Muddati": "Term",
  "Muddati o'tgan invoyslar": "Overdue invoices",
  "Narx o'sish qadami (so'm)": "Price step (UZS)",
  "Narxi": "Price",
  "Narxni o'zgartirish": "Change price",
  "Nomi": "Name",
  "Nomi (o'zbekcha) *": "Name (Uzbek) *",
  "Nomi (ruscha)": "Name (Russian)",
  "O'chirish": "Delete",
  "O'lchov birligi *": "Unit of measure *",
  "O'rmon xo'jaligi": "Forestry",
  "O'rmon xo'jaligi *": "Forestry *",
  "O'sish qadami": "Step",
  "Ochiq muammolar": "Open issues",
  "Ochiq muammolar: {0} ta": "Open issues: {0}",
  "Ochiq sahifada ko'rish": "View on the public page",
  "Oldingi": "Previous",
  "Olib tashlash": "Remove",
  "Ombor kirimi": "Stock receipt",
  "Omborda": "In stock",
  "Onlayn tranzaksiya yo'q.": "No online transactions.",
  "Onlayn tranzaksiyalar": "Online transactions",
  "Operatsiya turi *": "Operation type *",
  "Oxirgi 12 oy: hisoblangan invoyslar va tushgan to'lovlar (mln so'm)": "Last 12 months: invoiced and received payments (million UZS)",
  "Oxirgi rasm o'chirildi.": "The last image was deleted.",
  "Oxirgisini o'chirish": "Delete the last one",
  "Oy": "Month",
  "Oy bo'yicha filtr": "Filter by month",
  "Oylar bo'yicha hisoblangan va to'langan summa": "Invoiced and paid amounts by month",
  "Penya": "Penalty",
  "Poligonda kamida 3 ta nuqta bo'lishi kerak.": "A polygon needs at least 3 points.",
  "Publik portal": "Public portal",
  "Qarz": "Debt",
  "Qarz: {0} · To'langan: {1}": "Debt: {0} · Paid: {1}",
  "Qarzdorlar": "Debtors",
  "Qarzdorlik": "Debt",
  "Qarzdorlik qancha?": "How much is owed?",
  "Qatorni bosing — ariza kartochkasida bosqichlar va ERI bilan tasdiqlash": "Click a row — stages and e-signature approval are on the application card",
  "Qatorni o'chirish": "Delete row",
  "Qiymati": "Value",
  "Qoldiq": "Balance",
  "Qolgan vaqt": "Time left",
  "Raqam": "Number",
  "Rasm qo'shish": "Add image",
  "Rasm tanlash": "Choose images",
  "Rasm yo'q.": "No images.",
  "Rasm yuklandi.": "Image uploaded.",
  "Rasmlar": "Images",
  "Rasmlar (ko'pi bilan {0} ta)": "Images (up to {0})",
  "Reestr": "Register",
  "Ruxsat etilgan foydalanish": "Permitted use",
  "Ruxsat etilgan qurilish": "Permitted construction",
  "STIR": "TIN",
  "Salom! Men Smart Forestry AI yordamchisiman. Hududingizdagi mahsulotlar, ijara va to'lovlar haqida so'rang yoki bo'limni ochishni ayting.": "Hello! I'm the Smart Forestry AI assistant. Ask about your region's products, leases and payments, or ask me to open a section.",
  "Sana": "Date",
  "Saqlandi, lekin bajarilmadi — {0}.": "Saved, but this failed — {0}.",
  "Saqlanmoqda…": "Saving…",
  "Saqlash": "Save",
  "Shartnoma": "Contract",
  "Shartnoma egalari": "Contract holders",
  "Shartnoma raqami, ijarachi yoki STIR…": "Contract no., lessee or TIN…",
  "Shartnoma yo'q.": "No contracts.",
  "Shartnoma: {0}": "Contract: {0}",
  "Shartnomalar": "Contracts",
  "Smart Forestry": "Smart Forestry",
  "Sotuv narxi": "Selling price",
  "Sotuv narxi (so'm)": "Selling price (UZS)",
  "Summa": "Amount",
  "Tahrirlash": "Edit",
  "Tavsif": "Description",
  "Tavsiya etilgan narx (so'm)": "Recommended price (UZS)",
  "Telefon": "Phone",
  "Tizim": "System",
  "To'langan": "Paid",
  "To'langan / hisoblangan": "Paid / invoiced",
  "To'lov bo'limlari": "Payment sections",
  "To'lov hujjati": "Payment document",
  "To'lov hujjati raqami…": "Payment document no.…",
  "To'lov kutilmoqda": "Awaiting payment",
  "To'lov kutilmoqda. To'lov tasdiqlangach buyurtmani yuborish mumkin bo'ladi.": "Awaiting payment. The order can be shipped once the payment is confirmed.",
  "To'lov muddati": "Due date",
  "To'lov yo'q.": "No payments.",
  "To'lovlar": "Payments",
  "To'lovlar dinamikasi": "Payment trend",
  "Tovarlar": "Goods",
  "Trek / yuk xati raqami": "Tracking / waybill no.",
  "Trek raqami": "Tracking no.",
  "Tugash": "End",
  "Tugashi": "Ends",
  "Tuman": "District",
  "Uchastka": "Plot",
  "Uchastka *": "Plot *",
  "Uchastka ID, kadastr yoki ijarachi…": "Plot ID, cadastre or lessee…",
  "Uchastka ID, kadastr, ijarachi yoki STIR…": "Plot ID, cadastre, lessee or TIN…",
  "Uchastka chegarasi (GeoJSON) kiritilmagan.": "The plot boundary (GeoJSON) is missing.",
  "Uchastka chegarasini chizing yoki GeoJSON biriktiring.": "Draw the plot boundary or attach GeoJSON.",
  "Uchastka topilmadi.": "No plots found.",
  "Uchastka {0} o'chirildi.": "Plot {0} was deleted.",
  "Uchastka {0} o'chirilsinmi?": "Delete plot {0}?",
  "Uchastka {0} qo'shildi.": "Plot {0} was added.",
  "Uchastka {0} saqlandi.": "Plot {0} was saved.",
  "Uchastkalar": "Plots",
  "Uchastkalar ({0})": "Plots ({0})",
  "Uchastkalar hisob-kitobi ({0})": "Plot settlements ({0})",
  "Uchastkalar kesimida: shartnoma egalari va shartnomalar": "By plot: contract holders and contracts",
  "Uchastkani qidirish": "Search plots",
  "Uchastkani qo'shish": "Add plot",
  "Undirish darajasi": "Collection rate",
  "Usul": "Method",
  "Xaridor": "Buyer",
  "Xaridor muammolari": "Buyer issues",
  "Xaridor qabul qilganini o'zi tasdiqlaydi. Tasdiqlamasa, shu yerdan belgilang.": "The buyer confirms receipt themselves. If they don't, mark it here.",
  "Xaritada chizing yoki GeoJSON fayl/matn biriktiring.": "Draw on the map or attach a GeoJSON file/text.",
  "Xaritada chizish": "Draw on the map",
  "Xaritada poligonni yoki ro'yxatdagi uchastkani tanlang.": "Select a polygon on the map or a plot from the list.",
  "Xo'jalik": "Farm",
  "Xususiyat nomi": "Property name",
  "Xususiyat qiymati": "Property value",
  "Xususiyat qo'shish": "Add property",
  "Xususiyatlar (masalan: Uzunligi — 4 m)": "Properties (e.g. Length — 4 m)",
  "Yakun": "End",
  "Yakuniy narx": "Final price",
  "Yakunlangan": "Completed",
  "Yangi ariza": "New application",
  "Yangi chegara": "New boundary",
  "Yangi mahsulot": "New product",
  "Yangi uchastka": "New plot",
  "Yaratilgach darhol Yashil olamda e'lon qilish (narx va qoldiq kerak)": "Publish on Green World right after creation (price and stock required)",
  "Yaratish": "Create",
  "Yashil olamda": "On Green World",
  "Yer toifasi": "Land category",
  "Yetkazib berish shartlari": "Delivery terms",
  "Yetkazildi deb belgilash": "Mark as delivered",
  "Yetkazilgan": "Delivered",
  "Yetkazilganlar summasi": "Delivered total",
  "Yillik": "Annual",
  "Yo'lda": "In transit",
  "Yoki GeoJSON matnini shu yerga qo'ying": "Or paste the GeoJSON text here",
  "Yuborilishi kerak": "To ship",
  "Yuborish": "Ship",
  "Yuborishga tayyor": "Ready to ship",
  "Zakalat": "Deposit",
  "Zakalat puli (so'm)": "Deposit amount (UZS)",
  "Zaxira": "Stock",
  "avvalgi": "previous",
  "bekor qilingan": "cancelled",
  "bozorda": "on the market",
  "e'lon qilingan": "published",
  "e'lon qilinmagan": "unpublished",
  "ga": "ha",
  "hozirgi": "current",
  "mln so'm": "million UZS",
  "muammo: {0}": "issue: {0}",
  "muddati tugagan": "expired",
  "o'chirish": "remove",
  "qabul qilingan": "accepted",
  "{0} ga": "{0} ha",
  "{0} ga · qarz {1}": "{0} ha · debt {1}",
  "{0} kishi": "{0} people",
  "{0} kun kechikkan": "{0} days overdue",
  "{0} · {1} ga": "{0} · {1} ha",
  "«Ijaraga mo'ljallangan» uchastka yo'q: avval «Mening uchastkalarim» da uchastka qo'shing.": "No “Designated for lease” plots: first add a plot under “My plots”.",
  "— tanlang —": "— select —",
  "— tanlanmagan —": "— not selected —",
  "yan": "Jan",
  "fev": "Feb",
  "mar": "Mar",
  "apr": "Apr",
  "may": "May",
  "iyn": "Jun",
  "iyl": "Jul",
  "avg": "Aug",
  "sen": "Sep",
  "okt": "Oct",
  "noy": "Nov",
  "dek": "Dec",
  "Tugagan": "Finished",
  "Bekor qilingan": "Cancelled",
  "Jarayondagilar": "In progress",
  "Bekor qilingan lotlar": "Cancelled",
  "Bekor qilinganlar": "Cancelled",
  "Yetkazib tugallanganlar": "Delivered and completed",
  "Uzoq muddatli ijara": "Long-term lease",
  "Muddatli foydalanish": "Fixed-term use",
  "Mavsumiy foydalanish": "Seasonal use",
  "Mavsumiy": "Seasonal",
  "Muddatli": "Fixed-term",
  "Uzoq muddatli": "Long-term",
  "kutilmoqda": "pending",
  "muvaffaqiyatli": "successful",
  "xato": "failed",
  "Ijaraga mo'ljallangan": "Designated for lease",
  "Ijaraga chiqarildi": "Offered for lease",
  "Foydalanishda": "In use",
  "Tugatilgan": "Terminated",
  "Loyiha ariza": "Draft application",
  "Tekshiruvda": "Under review",
  "Xatolik aniqlandi": "Error found",
  "O'rmon xo'jaligi tasdiqladi": "Forestry approved",
  "E-ijaraga yuborildi": "Sent to E-lease",
  "Loyihalashda": "In design",
  "O'rmon xo'jaligi kelishuvida": "Forestry coordination",
  "Qayta ishlashga qaytarildi": "Returned for rework",
  "Idoralararo kelishuvda": "Interagency coordination",
  "Agentlik kelishuvida": "Agency coordination",
  "Kelishildi": "Agreed",
  "Auksionga chiqarildi": "Put up for auction",
  "G'olib aniqlandi": "Winner determined",
  "Ijaraga berildi": "Leased out",
  "Auksion amalga oshmadi": "Auction failed",
  "Rad etildi": "Rejected",
  "Shartnoma bekor qilindi": "Contract cancelled",
  "Amaldagi ijara": "Active lease",
  "Muddati yaqinlashmoqda": "Expiring soon",
  "Muddati tugagan": "Expired",
  "Qarzdor": "Debtor",
  "Qoidabuzarlik": "Violation",
  "Qoidabuzarlik aniqlangan": "Violation detected",
  "Faol": "Active",
  "Sotuvda": "On sale",
  "Yopilgan": "Closed",
  "Cheklangan": "Restricted",
  "Amalda": "In force",
  "To'xtatilgan": "Suspended",
  "Yangi": "New",
  "Qisman to'langan": "Partially paid",
  "Muddati o'tgan": "Overdue",
  "G'aznachilik": "Treasury",
  "Bank o'tkazmasi": "Bank transfer",
  "Naqd": "Cash",
  "Onlayn to'lov": "Online payment",
  "Qabul qilindi": "Accepted",
  "Qayta kelishuv": "Renegotiation",
  "To'landi": "Paid",
  "Yetkazilmoqda": "Being delivered",
  "Yetkazildi": "Delivered",
  "Bekor qilindi": "Cancelled",
  "Faol savdo": "Active auction",
  "Muvaffaqiyatli yakunlangan": "Successfully completed",
  "O'tkazilmagan deb topilgan": "Declared failed",
  "Shartnoma yaratish jarayonida": "Contract being prepared",
  "Loyihalash": "Design",
  "O'rmon xo'jaligi tashkilotida": "At the forestry organisation",
  "Idoraviy kelishuv": "Interagency coordination",
  "O'rmon xo'jaligi agentligi": "Forestry Agency",
  "E-AUKSION": "E-AUKSION",
  "Davlat kadastrlari palatasi": "State Cadastres Chamber",
  "Kutilmoqda": "Pending",
  "Ko'rib chiqilmoqda": "Under consideration",
  "Yakunlandi": "Completed",
};
